import { useEffect } from "react";
import { useSearchParams } from "react-router";
import PaymentSuccessCard from "../components/PaymentSuccessCard";
import { clearCheckoutSession } from "../utils/checkoutSession";

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? "your email";

  useEffect(() => {
    clearCheckoutSession();
  }, []);

  return (
    <div className="landing-payment-success px-4 py-16">
      <div className="relative z-10 w-full">
        <PaymentSuccessCard email={email} />
      </div>
    </div>
  );
}
